<!--
 * @Author: your name
 * @Date: 2022-01-07 11:18:44
 * @LastEditTime: 2022-01-07 16:21:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\views\workbench\index.vue
-->
<template>
  <div class="workbench">
    <div class="workbench-left">
      <div class="workbench-head">
        <h3>张东旭，欢迎来到工作台</h3>
        <p>空间可由一个或多个团队构成，在团队中可对只是和成员进行组织和管理。</p>
        <img src="~@/assets/bg.png" alt="/" />
        <span class="iconfont icon-cuohao close"></span>
        <div class="add-pro">
          <span class="iconfont icon-tianjia-copy"></span>
          <div>
            <p>协作项目</p>
            <span>新建协作项目</span>
          </div>
        </div>
      </div>
      <div class="workbench-content"></div>
    </div>
    <div class="workbench-right"></div>
  </div>
</template>
<script>
export default {
  name: 'Workbench',
  data() {
    return {
      title: '工作台'
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
